import { render, staticRenderFns } from "./UserPasswordChange.vue?vue&type=template&id=22437aee&"
import script from "./UserPasswordChange.vue?vue&type=script&lang=js&"
export * from "./UserPasswordChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports